import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
export interface Props {
  icon: ReactNode;
  content: ReactNode;
  className?: string;
  contentClassName?: string;
  errorMsg?: ReactNode;
}

const ArtOrderDetailsItem = ({
  icon,
  content,
  className,
  contentClassName,
  errorMsg,
}: Props) => {
  return (
    <>
      <div className={twMerge("flex gap-x-4 items-center", className)}>
        {icon}
        <span className={twMerge("flex flex-col gap-y-1", contentClassName)}>
          {content}
        </span>
      </div>
      {errorMsg}
    </>
  );
};

export default ArtOrderDetailsItem;
